var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9907 2.46976C35.1328 2.46976 35.2691 2.5262 35.3695 2.62667C35.47 2.72714 35.5264 2.86341 35.5264 3.0055V34.9945C35.5264 35.1366 35.47 35.2729 35.3695 35.3733C35.2691 35.4738 35.1328 35.5303 34.9907 35.5303H3.0055C2.86341 35.5303 2.72714 35.4738 2.62667 35.3733C2.5262 35.2729 2.46975 35.1366 2.46975 34.9945V3.0055C2.46975 2.86341 2.5262 2.72714 2.62667 2.62667C2.72714 2.5262 2.86341 2.46976 3.0055 2.46976H34.9945H34.9907ZM34.9945 2.402e-06H3.0055C2.20839 2.402e-06 1.44393 0.316653 0.880291 0.880293C0.31665 1.44393 0 2.20839 0 3.0055V34.9945C0.00100689 35.791 0.318101 36.5544 0.881633 37.1173C1.44516 37.6801 2.20905 37.9962 3.0055 37.9962H34.9945C35.7916 37.9962 36.5561 37.6796 37.1197 37.1159C37.6833 36.5523 38 35.7878 38 34.9907V3.0055C38 2.61049 37.9221 2.21936 37.7709 1.85447C37.6196 1.48958 37.3979 1.15808 37.1184 0.878949C36.8389 0.599813 36.5071 0.378508 36.142 0.227691C35.7769 0.0768741 35.3857 -0.000496976 34.9907 2.402e-06H34.9945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2988 13.8306H8.8418V29.6864H13.2988V13.8306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0252 13.8306C20.2066 13.8306 20.1382 16.0381 20.1382 16.1901V13.8306H15.5786V29.6864H20.1382V20.6357C20.1382 19.929 20.3471 18.4091 22.5053 18.4091C24.6635 18.4091 24.6445 20.5863 24.6445 20.5863V29.7054H29.1547V19.8264C29.1547 15.1414 26.5975 13.8306 24.0252 13.8306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0684 12.763C12.2981 12.763 13.295 11.7661 13.295 10.5364C13.295 9.30669 12.2981 8.30981 11.0684 8.30981C9.83867 8.30981 8.8418 9.30669 8.8418 10.5364C8.8418 11.7661 9.83867 12.763 11.0684 12.763Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.75f905d35805b015f14e29973faf0da0.svg";
export { ForwardRef as ReactComponent };